<script>
    import Piece from './piece.svelte'

    export let chosenPalette
    export let bgColor
    export let passStyle = ""
    export let stack = 3

</script>

<style>
    .totem {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        justify-content: center;
    }
</style>

<div class="totem" style={passStyle}>
    <Piece chosenPalette={chosenPalette}  bgColor={bgColor} />
    <Piece chosenPalette={chosenPalette}  bgColor={bgColor} />
    {#if stack == 3}
        <Piece chosenPalette={chosenPalette}  bgColor={bgColor} />
    {/if}
</div>